type DeadlineType = {
  day: number,
  time: string,
  weeks_before: number,
}

export type Deadlines = {
  artwork: DeadlineType,
  booking: DeadlineType,
  editorial: DeadlineType,
  ofi: DeadlineType,
}

export type PublicationModel = {
  artwork_email?: string,
  booking_api?: string,
  booking_email?: string,
  cache_key: number,
  compatible_pagination_ids?: number[],
  day_published?: string,
  deadlines?: Deadlines,
  editorial_email?: string,
  email?: string,
  features?: {
    editorial?: boolean,
    ofi?: boolean,
  },
  ftp_host?: string,
  ftp_password?: string,
  ftp_path?: string,
  ftp_port?: string,
  ftp_username?: string,
  id: number,
  instructions?: string,
  logo: {
    file_name?: string | null,
    original: string | null,
    thumb: string | null,
  },
  ofi_email?: string,
  options?: {
    accept_bookings_after_deadline?: boolean,
    allow_user_revert?: boolean,
    booking_api_mode?: string,
    booking_confirmation_id_method?: string,
    cancellation_api_enabled?: boolean,
    deadline_version?: string,
    disable_api_bookings_after_deadline?: boolean,
    disable_preflight?: boolean,
    file_transfer_protocol?: string,
    inspection_format?: string,
    sftp_login_details?: {
      host: string,
      password: string,
      path: string,
      username: string,
    },
  },
  page_rows?: string,
  page_columns?: string,
  price_lists?: {
    [key: string]: {
      id: number,
      service_id: number,
    },
  },
  provider_assigned_brand_ids?: number[],
  provider_id: number,
  provider_price_list_id?: number,
  publication_identifier?: string,
  time_zone?: string,
  title: string,
}

const state = {
  artwork_email: '',
  booking_api: '',
  booking_email: '',
  day_published: '',
  deadlines: {},
  editorial_email: '',
  email: '',
  features: {
    editorial: false,
    ofi: false,
  },
  ftp_host: '',
  ftp_password: '',
  ftp_path: '',
  ftp_port: '',
  ftp_username: '',
  id: null,
  instructions: '',
  ofi_email: '',
  options: {
    accept_bookings_after_deadline: true,
    allow_user_revert: false,
    booking_api_mode: '',
    booking_confirmation_id_method: '',
    cancellation_api_enabled: false,
    deadline_version: 'V1',
    disable_preflight: false,
    file_transfer_protocol: '',
    inspection_format: '',
    sftp_login_details: {
      host: '',
      password: '',
      path: '',
      username: '',
    },
  },
  page_rows: '',
  page_columns: '',
  provider_id: undefined,
  provider_price_list_id: undefined,
  publication_identifier: '',
  time_zone: 'Australia/Sydney',
  title: '',
}

export const requiredFields = [
  { key: 'provider_id' },
  { key: 'title' },
]

export default state
